import { Component, OnInit, TemplateRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../_service/message-service';
import { Subscription, timer } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { AuthenticationService, UserService } from 'src/app/_services';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { map, take } from 'rxjs/operators';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { Role } from 'src/app/util/enums/role.enum';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { UserTypes } from 'src/app/shared/interfaces/userType.model';
import { Permission } from 'src/app/util/enums/permission.enum';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { HttpClient } from '@angular/common/http';

export interface mobileusers {
  mobile: number;
  username: string;
  email: string;
  platform: string;
  createdDate: string;
  enable: string;
  no: number;
  userId: number;
  idTag: string;
  enableEmail: boolean;
  activateRfid: boolean;
  mobileValidated: boolean;
  tenantId: string;
}

@Component({
  selector: 'telio-mobile-users',
  templateUrl: './mobile-users.component.html',
  styleUrls: ['./mobile-users.component.scss'],
})

export class MobileUsersComponent implements OnInit, OnDestroy {
  @ViewChild('callOtpDialog', { static: false }) callOtpDialog: TemplateRef<any>;
  @ViewChild('viewUserDetails', { static: false }) viewUserDetails: TemplateRef<any>;
  @Input() actionFeatureFlag = false;
  otpForm: UntypedFormGroup;
  userSubscription = new Subscription()
  description: any;
  users: any = [];
  mobileusers: mobileusers[];
  data: mobileusers[];
  deleteid: any;
  userDetails;
  cookieDetails;
  keyFob;
  otpMessage;
  keyFobPopup = false;
  emailPopup = false;
  otpRegEx: RegExp = /^[0-9]{6}$/;
  enableCreateUser = false;
  columns: TableColumn[];
  buttons: TableBtn[];
  filterPlaceholder: string = '';
  actionHeader: string = '';
  subscription: Subscription = new Subscription;
  initialData: any;
  actionFeatureLabel: string = 'mobileUsers.createUser';

  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  editid;
  userId;
  tempEmail;
  tempKey;
  enableResend = false;
  countDown: Subscription;
  clock = 0;
  tick = 1000;
  editUserData = [];

  constructor(private userService: UserService,
    private toastr: SnackbarService,
    private router: Router,private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
    readonly exportCSVService: ExportCSVService,
    private userInfoService: UserInfoService,
    private rfidService: RfidServiceService,
    public loaderService: LoaderService,
    public dialog: MatDialog,readonly breadcrumbService: BreadcrumbService,
    readonly route: ActivatedRoute,private authenticationService: AuthenticationService,
    public translate: TranslateService) {
    this.cookieDetails = this.userInfoService.userDetails;
    this.enableCreateUser = this.userInfoService.isAdminGroup()  ? true : false;
    this.cookieDetails = this.userInfoService.userDetails;
  }

  ngOnInit(): void {
    this.columns = [
      { columnDef: 'userId', header: 'mobileUsers.userId', cell: (element: mobileusers) => `${element.userId}`, sortingDisabled: false, width: '100px', },
      { columnDef: 'username', header: 'mobileUsers.name', cell: (element: mobileusers) => `${element.username}`, sortingDisabled: false, width: '100px', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'email', header: 'mobileUsers.email', cell: (element: mobileusers) => `${element.email}`, sortingDisabled: false, width: '150px' },
      { columnDef: 'mobile', header: 'mobileUsers.mobile', cell: (element: mobileusers) => `${element.mobile}`, sortingDisabled: false, width: '150px' },
      { columnDef: 'platform', header: 'mobileUsers.platform', cell: (element: mobileusers) => `${element.platform}`, sortingDisabled: true, width: '100px' },
      { columnDef: 'tenantId', header: 'tenantForm.tenantId', cell: (element: mobileusers) => `${element.tenantId}`, sortingDisabled: true, width: '100px' },
      { columnDef: 'createdDate', header: 'mobileUsers.createdDate', cell: (element: mobileusers) => `${element.createdDate}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'idTag', header: 'mobileUsers.rfidTag', cell: (element: mobileusers) => `${element.idTag}`, sortingDisabled: true, width: '100px' }
    ];

    this.buttons = [
      { styleClass: 'submit', icon: 'account_circle', payload: (element: mobileusers) => `${element.userId}`, action: 'activateUser', tooltip: 'mobileUsers.activateUser', isDisabled: (element: mobileusers) => `${element.mobileValidated != false}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'email', payload: (element: mobileusers) => `${element.userId}`, action: 'email', tooltip: 'mobileUsers.verifyEmail', isDisabled: (element: mobileusers) => `${element.enableEmail != false}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'done', payload: (element: mobileusers) => `${element.userId}`, action: 'rfid', tooltip: 'mobileUsers.activate', isDisabled: (element: mobileusers) => `${element.activateRfid != true}`, enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      // { styleClass: 'submit', icon: 'delete', payload: (element: mobileusers) => `${element.userId}`, action: 'delete', tooltip: 'mobileUsers.delete', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE) },
      { styleClass: 'submit', icon: 'edit', payload: (element: mobileusers) => `${element.userId}`, action: 'edit', tooltip: 'mobileUsers.edit', enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) }
    ];

    this.actionHeader = 'mobileUsers.action';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
    this.enableCreateUser = true;
    this.rerender(this.pageList, '');
    this.otpForm = this.formBuilder.group({
      otp: [null, Validators.compose([
        Validators.required,
        Validators.pattern(this.otpRegEx)
      ])]
    })
  }

  getmobileUsers(value: any, searchFilter: string = '') {
    this.subscription.add(this.userService.getAllUsers(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter, UserTypes.mobileUsers)
      .pipe(map(events => {
        this.data = events.data.content
        this.setMobileUserMap(events.data.content);
        this.totalDataCount = events.data.total_items;
      })).subscribe());
  }

  setMobileUserMap(events) {
    if (!!events && events.length > 0) {
      events.map((event: any, i: number) => {
        let empty = 'NA';
        event.userId = !event.user.userId ? empty : event.user.userId;
        event.username = !event.user.username ? empty : event.user.username;
        event.mobile = !event.user.mobile ? empty : event.user.mobile;
        event.email = (!event.user.email && !event.user.tempEmail) ? empty : this.getEmail(event.user)
        event.platform = !event.user.platform ? empty : event.user.platform;
        event.tenantId = !event.user.tenantId ? empty : event.user.tenantId;
        event.createdDate = !event.user.createdDate ? empty :this.authenticationService.convertToLocalTime(event.user.createdDate,this.userInfoService.userDetails.prefCountry).split(' ')[0];
        event.idTag = !event.auth ? empty : (!event.auth.idTag ? empty :event.auth.idTag);
        event.enableEmail = (!!event.user.tempEmail && !event.user.emailValidated) ? false : true
        event.activateRfid = this.getRfidStatus(event)
      })
    }
    else {
      this.data = []
    }
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  getEmail_bkp(user) {
    if (!!user.email) {
      return user.email
    }
    else {
      return user.tempEmail
    }
  }

  getEmail(user) {
    if (user.emailValidated) {
      return user.email
    }
    else {
      return user.tempEmail
    }
  }

  getRfidStatus(event) {
    if (!!event.auth) {
      if (!!event.auth.status) {
        if (event.auth.status.toLowerCase() == 'pending for activation') {
          return true
        }
        else {
          return false
        }
      }
    }
    else {
      return false
    }
  }

  buttonClick(result: string[]) {
    switch (result[0]) {
      case 'delete':
        this.deleteid = result[1]
        this.deleteUser(this.deleteid);
        break;
      case 'email':
        let item = this.data.filter(res => res.userId == +result[1])
        this.emailVerification(item);
        break;
      case 'rfid':
        let rfid = this.data.filter(res => res.userId == +result[1])
        this.activateRfid(rfid);
        break;
      case 'activateUser':
        let data = this.data.filter(res => res.userId == +result[1])
        this.activateUser(data);
      case 'edit':
        this.editid = result[1]
        this.editUser(this.editid)
        break;
      default:
        break
    }
  }

  deleteuserbyemail() {
    this.userService.deleteUserById(this.deleteid).subscribe(
      (resp: any) => {
        if (resp != null) {
          this.toastr.success(resp.status_message);
          this.rerender(this.pageList, '');
        }
        else {
          this.toastr.error(resp.status_message);
        }
      },
      error => {
        this.toastr.error(this.translate.instant('responseFailed'))
      }
    );
  }

  rerender(value: any, searchFilter?: string): void {
    this.getmobileUsers(value, searchFilter)
  }

  actionClick() {
    this.rerender(this.pageList);
  }

  //csv download
  actionCSV() {
    const options = {
      filename: this.translate.instant('mobileUsers.mobileFileName'),
      showTitle: false,
      title: this.translate.instant('mobileUsers.mobileFileName'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userService.getAllUsers(1,this.totalDataCount,this.sortColumn, 'asc','', UserTypes.mobileUsers).subscribe(
      (resp:any)=>{
        let csvData =resp.data.content
        this.setMobileUserMap(csvData);
        csvData = csvData.map((item:any)=>{
          delete item.user;
          delete item.auth;
          delete item.chargebox_count;
          delete item.enableEmail
          return item
         })
        this.exportCSVService.exportCSV(options, csvData);
      }
    ));
  }

  dateTransformCreatedDate(date: string) {
    let dateIn: Date = new Date(date);
    dateIn.setHours(dateIn.getHours() + 5);
    dateIn.setMinutes(dateIn.getMinutes() + 30);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 10);
    return dateOut;
  }

  actionFeature(event) {
    this.userService.getLanguagesbycountry().subscribe((res: any) => {
      if (!!res) {
        let filterCountries = res.map((resp: any) => resp.country.toLowerCase());
        let objToSend: NavigationExtras = {
          queryParams: {
            listedCountries: filterCountries,
          },
          skipLocationChange: true
        };

        this.router.navigate(["/dashboard/mobile-users/create", { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
         this.breadcrumbService.emitBreadCrumbs(RouteConstants.MOBILE_USERS_CREATE);   
      }
    })
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  activateRfid(item) {
    this.emailPopup = false;
    this.otpMessage = this.translate.instant('mobileUsers.keyFobMessage')
    this.keyFob = item[0].auth.idTag
    this.userSubscription.add(this.rfidService.getOtpRFid(this.keyFob).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(resp.status_message)
        this.openOtpDailog()
        this.resendTimeout()
        this.resendTimer()
        this.keyFobPopup = true
      }
    },
      error => {
        this.toastr.error(error.message);
      }))
  }

  activateUser(item) {
    this.keyFobPopup = false
    this.otpMessage = this.translate.instant('mobileUsers.verifyMobile')
    this.userId = item.user.userId
    this.tempKey = item.user.mobile
    this.sendOtp()
  }

  openOtpDailog() {
    this.otpForm.reset();
    let dialogRef = this.dialog.open(this.callOtpDialog, {
      height: '500px',
      width: '500px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  resendTimer() {
    this.clock = 120;
    this.countDown = timer(0, this.tick)
      .pipe(take(this.clock))
      .subscribe(() => {
        --this.clock;
        if (this.clock == 0) {
          this.countDown.unsubscribe();
        }
      });
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  resendTimeout() {
    setTimeout(() => {
      this.enableResend = true
    }, 120000);
  }

  submitOTP() {
    this.keyFobPopup ? this.submitKeyFobOtp() : this.submitEmailOtp()
  }

  submitKeyFobOtp() {
    let otp = this.otpForm.value.otp;
    let input = {
      "otp": otp
    }
    let logs = this.translate.instant('mobileUsers.logsActivated') + this.cookieDetails.email
    this.rfidService.patchOtpActivate(this.keyFob, input, logs).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('mobileUsers.activateSuccess'));
        this.dialog.closeAll();
        this.rerender(this.pageList, '');
      }
    },
      error => {
        this.toastr.error(error.message);
      }
    )
  }

  submitEmailOtp() {
    let id = this.userId
    let otp = this.otpForm.value.otp
    let key = this.tempKey
    this.userSubscription.add(this.userService.otpValidation(id, otp, key).subscribe(resp => {
      switch (resp.status_code) {
        case 3000:
          this.toastr.error(resp.status_message)
          break
        case 1000:
          this.toastr.success(resp.status_message)
          this.dialog.closeAll();
          this.rerender(this.pageList, '');
          break
      }
    },
      error => {
        this.toastr.error(error.message)
      }
    ))
  }

  emailVerification(item) {
    this.keyFobPopup = false
    this.otpMessage = this.translate.instant('mobileUsers.emailMessage')
    this.userId = item[0].user.userId
    this.tempKey = item[0].user.tempEmail
    this.sendOtp()
  }

  sendOtp() {
    this.userSubscription.add(this.userService.getEmailOtp(this.userId, this.tempKey).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.otpMessage)
        this.openOtpDailog()
        this.resendTimeout()
        this.resendTimer()
        this.emailPopup = true
      }
    },
      error => {
        this.toastr.error(error)
      }
    ))
  }

  deleteUser(id): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('mobileUsers.delete'), otherbtn: this.translate.instant('faq.confirmNo') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deleteuserbyemail();
      }
    });
  }

  resend() {
    this.keyFob ? this.resendRfidOtp() : this.resendOtp()
  }

  resendRfidOtp() {
    this.enableResend = false;
    this.userSubscription.add(this.rfidService.getOtpRFid(this.keyFob).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(resp.status_message)
        this.resendTimeout()
        this.resendTimer()
        this.keyFobPopup = true
      }
    },
      error => {
        this.toastr.error(error.message);
      }))
  }

  resendOtp() {
    this.enableResend = false;
    this.userSubscription.add(this.userService.getEmailOtp(this.userId, this.tempKey).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.otpMessage)
        this.resendTimeout()
        this.resendTimer()
        this.emailPopup = true
      }
    },
      error => {
        this.toastr.error(error)
      }
    ))
  }

  ngOnDestroy() {
    this.userSubscription && this.userSubscription.unsubscribe();
  }

  userDetail(item) {
    this.userService.getUserDetails(item.userId).subscribe((resp: any) => {
      if (!!resp) {
        this.userDetails = resp.data;
        let empty = 'NA';
        let event = this.userDetails
        event.username = !event.username ? empty : event.username;
        event.email = !event.email ? empty : event.email;
        event.emailValidated = event.email_validated;
        event.mobile = !event.mobile ? empty : event.mobile;
        event.mobileValidated = event.mobile_validated;
        event.countryCode = !event.country_code ? '' : event.country_code;
        event.roles = (!event.roles && event.roles.length > 0) ? empty : event.roles[0].name;
        event.status = !event.status ? empty : event.status.toUpperCase();
        event.tenantId = !event.tenant_id ? empty : event.tenant_id;
        event.signupType = !event.signup_type ? empty : event.signup_type;
        event.prefLanguage = !event.pref_language ? empty : event.pref_language.toUpperCase();
        event.pancard = !event.pancard ? empty : event.pancard;
        event.gstNumber = !event.gst_number ? empty : event.gst_number;
        event.state = !event.state ? empty : event.state;
        event.vehicleRegNo = !event.vehicle_reg_no ? empty : event.vehicle_reg_no;

        let dialogRef = this.dialog.open(this.viewUserDetails, {
          height: '500px',
          width: '800px'
        }).afterClosed().subscribe((res: any) => {
        })
      } else {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      }
    }, error => {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    })
  }

  linkClick(event) {
    this.userDetail(event.row);
  }

  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }

  editUser(id) {
    this.userService.getUserDetails(id).subscribe((res: any) => {
      if (!!res) {
        this.editUserData = res.data;
        this.userService.getLanguagesbycountry().subscribe((res: any) => {
          if (!!res) {
            let filterCountries = res.map((resp: any) => resp.country.toLowerCase());
            let objToSend: NavigationExtras = {
              queryParams: {
                listedCountries: filterCountries,
                "editUserData": JSON.stringify(this.editUserData),
                "isEdit": true,
              },
              skipLocationChange: true
            };
            this.router.navigate(["/dashboard/mobile-users/create", { routeID: this.route.snapshot.paramMap.get('routeID') }], objToSend);
            this.breadcrumbService.emitBreadCrumbs(RouteConstants.MOBILE_USERS_EDIT);
          }
        })
      }
    })
  }
}
